'use client';

import {
  SDGMarqueeRow,
  cmsCardToSlide,
  type SDGSlide,
} from '@/components/sections/Sustainability/SustainabilitySDGsSection';
import type { SustainabilityColorfulCardWrapper } from '@/types/sustainability';

export default function SustainabilityEnvironmentSDGMarquee({
  heading,
  intro,
  cardWrapper,
}: {
  heading: string;
  intro: string;
  cardWrapper?: SustainabilityColorfulCardWrapper | null;
}) {
  const cmsCards = [...(cardWrapper?.cardsRow1 ?? []), ...(cardWrapper?.cardRow2 ?? [])];
  const slides: SDGSlide[] = cmsCards.map(cmsCardToSlide);

  if (!heading && !intro && slides.length === 0) return null;

  return (
    <section className="relative z-10 bg-black text-white">
      <div className="w-full">
        {heading || intro ? (
          <div className="mx-auto max-w-3xl px-4 text-center sm:px-8">
            {heading ? (
              <h2 className="text-[1.75rem] font-bold tracking-tight text-white sm:text-4xl md:text-[2.35rem]">
                {heading}
              </h2>
            ) : null}
            {intro ? (
              <p className="mt-4 text-sm leading-relaxed text-neutral-300 sm:mt-5 sm:text-base md:text-lg">
                {intro}
              </p>
            ) : null}
          </div>
        ) : null}

        {slides.length > 0 ? (
          <div className="mt-8 sm:mt-10">
            <SDGMarqueeRow slides={slides} direction="forward" />
          </div>
        ) : null}
      </div>
    </section>
  );
}
